<template>
  <div class="fixed w-full h-screen bg-black bg-opacity-80 top-0 left-0 z-50">
    <span class="close cursor-pointer z-50" @click="closeMenu"></span>
    <div class="w-full h-full flex flex-col justify-center items-center">
      <div
        class="menu-wrapper w-full flex flex-col items-center justify-center text-center font-rajdhani text-2xl tracking-wider"
      >
        <a
          v-for="(menu, index) in mobileMenu"
          :key="index"
          v-html="menu.name"
          :href="menu.link"
          class="menuName uppercase mt-4 first:mt-0"
          @click="closeMenu"
        ></a>
      </div>
      <div
        class="link-cont w-full flex flex-row justify-center items-center mt-9"
      >
        <a
          class="link-wrapper mx-3"
          v-for="(linkMenu, index) in linkMenu"
          :key="index"
          :href="linkMenu.href"
        >
          <img :src="`${imgPath}${linkMenu.icon}`" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      mobileMenu: [
        {
          name: 'story',
          link: '#story',
        },
        {
          name: 'classes',
          link: '#class',
        },
        {
          name: 'Dungeons',
          link: '#dungeons',
        },
        {
          name: 'Legend Skills',
          link: '#skills',
        },
        {
          name: 'Champions',
          link: '#champions',
        },
        {
          name: 'Summonables',
          link: '#summonables',
        },
        {
          name: 'Stats Upgrade',
          link: '#stats',
        },
        {
          name: 'Companions',
          link: '#companions',
        },
        {
          name: 'Combat Content',
          link: '#combat',
        },
      ],
      linkMenu: [
        {
          name: 'home',
          icon: '/ico_home_mobile.png',
          href: 'https://latale.papayaplay.com/latale.do',
        },
        {
          name: 'discord',
          icon: '/ico_discord_mobile.png',
          href: 'https://discord.com/invite/latalena',
        },
        {
          name: 'facebook',
          icon: '/ico_fb_mobile.png',
          href: 'https://www.facebook.com/latalena/',
        },
        {
          name: 'tweeter',
          icon: '/ico_twit_mobile.png',
          href: 'https://www.twitter.com/papaya_latale',
        },
      ],
    };
  },
  methods: {
    closeMenu: function() {
      this.$store.commit('MENU_NAV_MOBILE/CLOSE_NAV');
    },
  },
};
</script>

<style lang="postcss" scoped>
.close {
  @apply absolute right-16 top-12 w-8 h-8 sm:right-6 sm:top-6;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #f1dcac;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.menu-wrapper .menuName {
  background: linear-gradient(to right, #ffebb5 0%, #e7bf73 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
